import { z } from "zod";

export enum MemberRole {
  Owner = "owner",
  Member = "member",
  Guest = "guest",
  Anonymous = "anonymous",
}

export const MemberRoleZod = z.enum(["owner", "member", "guest", "anonymous"]);
